import { C } from "../constants";
import { Modal } from "./ui";

export const SettingsModal = ({ settings, onChange, onClose }) => {
  const Toggle = ({ label, optA, optB, value, field, labelA, labelB, description }) => (
    <div style={{ padding: "16px 0", borderBottom: `1px solid ${C.border}` }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ fontWeight: 700, fontSize: 14, color: C.text }}>{label}</div>
        <div style={{ display: "flex", gap: 4, background: C.surface, borderRadius: 9, padding: 3, border: `1px solid ${C.border}` }}>
          {[[optA, labelA ?? optA], [optB, labelB ?? optB]].map(([opt, lbl]) => (
            <button key={String(opt)} onClick={() => onChange(field, opt)} style={{
              padding: "6px 18px", borderRadius: 7, border: "none", cursor: "pointer",
              fontWeight: 700, fontSize: 13,
              background: value === opt ? C.accent : "transparent",
              color: value === opt ? "#1e1d1b" : C.muted,
            }}>{lbl}</button>
          ))}
        </div>
      </div>
      {description && (
        <div style={{ color: C.muted, fontSize: 12, marginTop: 6, lineHeight: 1.4 }}>{description}</div>
      )}
    </div>
  );

  return (
    <Modal onClose={onClose} title={
      <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: C.blue }}>
          <circle cx="12" cy="12" r="3"></circle>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
        </svg>
        Settings
      </span>
    }>
      <Toggle label="Weight Units"   field="weightUnit" optA="lbs" optB="kg" value={settings.weightUnit} />
      <Toggle label="Distance Units" field="distUnit"   optA="mi"  optB="km" value={settings.distUnit}   />
      <Toggle
        label="Advanced Exercise Mode"
        field="advancedMode"
        optA={false} optB={true}
        labelA="Off"  labelB="On"
        value={!!settings.advancedMode}
        description="Enable detailed muscle targeting (primary, secondary, stabilisers)"
      />
      <div style={{ marginTop: 18, padding: "12px 16px", background: C.surface, borderRadius: 10, border: `1px solid ${C.border}` }}>
        <div style={{ color: C.muted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 6 }}>Note</div>
        <div style={{ color: C.textDim, fontSize: 12, lineHeight: 1.5 }}>
          Data is stored in lbs and miles internally. Units only affect how values are displayed and entered — switching won't alter your existing history.
        </div>
      </div>
    </Modal>
  );
};
